/**
 * 统计横向显示内容模型
 */
export default class ChargeCountItem {
  constructor(countName, currency, amount, style) {
    this._countName = countName // 显示名称
    this._currency = currency // 币种
    this._amount = amount // 金额
    this._style = style // 风格?
  }

  get countName() {
    return this._countName
  }

  set countName(value) {
    this._countName = value
  }

  get currency() {
    return this._currency
  }

  set currency(value) {
    this._currency = value
  }

  get amount() {
    return this._amount
  }

  set amount(value) {
    this._amount = value
  }

  get style() {
    return this._style
  }

  set style(value) {
    this._style = value
  }
}
